<template>
  <router-view></router-view>
</template>

<script>
import firebase from "firebase/app"

export default {
  name: 'App',

  data: () => ({
  }),
  created() {
    try {
      firebase.firestore().settings({
        ignoreUndefinedProperties: true,
      })
    } catch (err) {
      // Already started in some browsers; do not block the app shell.
    }
  },
};
</script>
